import styled from 'styled-components';

import type { WellnessBasketPrices } from '@wecasa/common/src/types/commons';
import { formatPrice } from '@wecasa/common/src/utils/formatting';

import type { MembershipOptIn } from '@wecasa/customer/src/modals/membership-paywall/utils';

import { translate } from '@wecasa/i18n';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';

import SelectablePriceCard, { type SelectablePriceCardProps } from '../selectable-price-card';

const t = translate('modals.membership_paywall.price_cards.standard');

const StyledCard = styled(SelectablePriceCard)`
  height: 85px;
`;

type SelectableWellnessStandardPriceCardProps = Pick<SelectablePriceCardProps, 'onPress'> & {
  numberOfSelectedPrestations: number;
  prices: WellnessBasketPrices;
  optInChoice?: MembershipOptIn;
};

const SelectableWellnessStandardPriceCard = ({
  numberOfSelectedPrestations,
  onPress,
  prices,
  optInChoice,
}: SelectableWellnessStandardPriceCardProps) => {
  const { totalPrice } = prices;
  const showPrice = numberOfSelectedPrestations > 0;

  return (
    <StyledCard
      isSelected={optInChoice === 'noMembership'}
      onPress={onPress}
      title={t('.pay_without_club')}
      value='noMembership'
    >
      {showPrice && <Text.MDBold>{formatPrice(totalPrice)}</Text.MDBold>}
    </StyledCard>
  );
};

export default SelectableWellnessStandardPriceCard;
